import {saveAs} from 'file-saver';
import {useNavigate} from 'react-router-dom';
import {Card} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import Level3Title from '../../../../../app/common/components/title/Level3Title';

const TELECHARGEMENTS_IDS = [
  'TELEPHONIE.SOFTPHONES.TELECHARGEMENT.DESKTOP_CONTROL',
  'TELEPHONIE.SOFTPHONES.TELECHARGEMENT.MANUEL_DESKTOP_CONTROL',
  'TELEPHONIE.SOFTPHONES.TELECHARGEMENT.MOBILE_CONTROL',
  'TELEPHONIE.SOFTPHONES.TELECHARGEMENT.MANUEL_MOBILE_CONTROL',
];

const telechargerFichier = (nom: string): void => {
  saveAs(new Blob(['Fichier fictif — maquette'], {type: 'application/octet-stream'}), nom);
};

/**
 * MAQUETTE — onglet « Softphones CELESTE » d'une prestation Centrex.
 * Données statiques : aucun appel API.
 */
const SoftphonesCeleste = (): JSX.Element => {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <div className="mt-4">
      <Card>
        <Card.Header>
          <Card.Title className="m-0">
            <Level3Title title={intl.formatMessage({id: 'DETAILS_TELEPHONIE.TAB.SOFTPHONES'})} />
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <p className="text-muted fs-6 mb-5">
            {intl.formatMessage({id: 'TELEPHONIE.SOFTPHONES.DESCRIPTION_1'})}{' '}
            <span
              className="text-primary cursor-pointer"
              onClick={() => navigate('/support-list')}
            >
              {intl.formatMessage({id: 'TELEPHONIE.SOFTPHONES.CONSEILLER_CELESTE'})}
            </span>{' '}
            {intl.formatMessage({id: 'TELEPHONIE.SOFTPHONES.DESCRIPTION_2'})}
          </p>
          <div className="d-flex flex-column gap-4">
            {TELECHARGEMENTS_IDS.map((labelId) => (
              <div
                key={labelId}
                className="d-flex align-items-center gap-3 text-primary cursor-pointer"
                onClick={() => telechargerFichier(`${intl.formatMessage({id: labelId})}.pdf`)}
              >
                <i className="bi bi-download fs-4" />
                <span className="fs-6">{intl.formatMessage({id: labelId})}</span>
              </div>
            ))}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default SoftphonesCeleste;
